export default "__VITE_ASSET__8bzUFCx0__"